import * as React from 'react';
import { SVGProps } from 'react';

const IconShuffleSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7.5 1H11v3.5L9.604 3.104 1.707 11 1 10.293l7.896-7.897L7.5 1z" />
    <path d="m1.707 1 3.586 3.586-.707.707L1 1.707 1.707 1zm7.896 7.896L7.414 6.707l-.707.707 2.19 2.19L7.5 11H11V7.5L9.603 8.896z" />
  </svg>
);
export default IconShuffleSizeXs;
